import Row from 'olive-react-myoneui/lib/Row';
import Col from 'olive-react-myoneui/lib/Col';
import { oliveLogo, mykademyLogo } from '../constants/icons';
import ErrorDescription from '../components/ErrorDescription';

function Error403() {
  return (
    <div className="error-wrapper px-3">
      <Row className="row justify-content-between align-items-center text-center min-vh-100">
        <Col lg={12} className="mb-4">
          <a href="#" className="logo-brand">
            {mykademyLogo}
          </a>
        </Col>
        <Col lg={12} className="mb-4">
          <ErrorDescription error404Title="403." error404Info="We are sorry!!! Access denied/ Forbidden" />
        </Col>
        <Col lg={12} className="mb-4">
          <p className="mb-0">You don't have permission to access this page.</p>
          {/* <p className="mb-0">
            Contact Administrator to get permission or <a href="#">Go back</a>, or head over to <a href="https://olive.io">olive.io</a> to choose a new direction
          </p> */}
        </Col>
      </Row>
    </div>
  );
}

export default Error403;
